import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { LegacyDockLogRow } from "app/data/dock-scan/models";
import TrackingService from "app/data/tracking/trackingService";

const trackingService = TrackingService.getInstance();

export interface ShipmentDockLogResult {
  rows: LegacyDockLogRow[];
  isLoading: boolean;
  isLoaded: boolean;
  legacyFailed: boolean;
  legacyError: string | null;
}

/** Legacy dock log only (tracking-service). Scan logs live on the Scan Logs tab. */
export function useShipmentDockLog(invoiceNumber?: number): ShipmentDockLogResult {
  const legacyQuery = useQuery({
    queryKey: [QUERY_KEYS.SHIPMENT_MERGED_DOCK_LOG, "legacy", invoiceNumber],
    queryFn: async () => {
      const response = await trackingService.getDockLog(invoiceNumber!);
      if (!response.ok()) {
        throw new Error(String(response.getError?.() || "Failed to load dock log"));
      }
      return (response.data || []) as LegacyDockLogRow[];
    },
    enabled: !!invoiceNumber,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const legacyFailed = legacyQuery.isError;

  return {
    rows: legacyQuery.data || [],
    isLoading: legacyQuery.isLoading,
    isLoaded: legacyQuery.isFetched,
    legacyFailed,
    legacyError: legacyFailed ? (legacyQuery.error as Error)?.message || null : null,
  };
}

/** @deprecated Use useShipmentDockLog */
export const useMergedDockLog = useShipmentDockLog;
